import { render, staticRenderFns } from "./SurveyScreen.vue?vue&type=template&id=087badb2&scoped=true&"
import script from "./SurveyScreen.vue?vue&type=script&lang=js&"
export * from "./SurveyScreen.vue?vue&type=script&lang=js&"
import style0 from "./SurveyScreen.vue?vue&type=style&index=0&id=087badb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087badb2",
  null
  
)

export default component.exports